import Icon from '@ant-design/icons';
import { message } from 'antd';
import classNames from 'classnames';
import { useEffect, useState } from 'react';

import RightIcon from '@/components/Icon/svgs/right.svg';
import MindverseModal, { SizeType } from '@/components/modal';
import { LAYOUT_SIZE } from '@/hooks/useLayoutSize';
import useStorage from '@/hooks/useStorage';
import { useTranslation } from '@/i18n/client';
import { updateUserSettings } from '@/service/language';
import useUserSettings from '@/store/useUserSettings';
import PreferLanguage from '@/ui/prefered-language';
import { EVENT } from '@/utils/event';

import styles from '../../index.less';
import { IconMap, MenuItem, MenuTNameMap } from '../constant';

interface IProps {}

const PreferredLanguageItem: React.FC<IProps> = () => {
  const [showModal, setShowModal] = useState<boolean>(false);

  const languageList = useUserSettings((state) => state.languageList);
  const fetchUserLanguage = useUserSettings((state) => state.fetchUserLanguage);
  const preferredLanguage = useUserSettings((state) => state.preferredLanguage);
  const [selectedLanguage, setSelectedLanguage] = useState<string>('');
  const [layoutSize] = useStorage('layoutSize');

  const { t } = useTranslation();

  // 获取用户设置
  useEffect(() => {
    setSelectedLanguage(preferredLanguage);
  }, [preferredLanguage]);

  // 点击确定更新用户设置
  const onOk = () => {
    updateUserSettings({ preferredLanguage: selectedLanguage })
      .then(() => {
        message.success('Update success');

        fetchUserLanguage();
      })
      .catch(() => {
        message.error('Update failed');

        setSelectedLanguage(preferredLanguage);
      });

    setShowModal(false);
  };

  return (
    <>
      {layoutSize === LAYOUT_SIZE.SMALL ? (
        <div
          className={styles.settingItem}
          onClick={() => {
            setShowModal(true);
            dispatchEvent(new Event(EVENT.FOLD_MENU));
          }}
        >
          <div className={styles.settingInfo}>
            <Icon component={IconMap[MenuItem.PreferredLanguage]} />
            <div>{t('menu.aiLanguage')}</div>
          </div>
          <div className="flex items-center">
            <div className="text-[#AD9B93]">
              {languageList.find((item) => {
                return item.languageCode === preferredLanguage;
              })?.nativeName ?? t('menu.aiLanguageSelect')}
            </div>
            <Icon className={styles.rightIcon} component={RightIcon} />
          </div>
        </div>
      ) : (
        <div
          className={classNames(styles.menuItem, 'pb-4', 'pt-4')}
          onClick={() => {
            setShowModal(true);
            dispatchEvent(new Event(EVENT.FOLD_MENU));
          }}
        >
          <div>
            <div>
              <Icon className={styles.icon} component={IconMap[MenuItem.PreferredLanguage]} />
              <span className={styles.text}>{t(MenuTNameMap[MenuItem.PreferredLanguage])}</span>
            </div>

            <div className={styles.language}>
              {languageList.find((item) => {
                return item.languageCode === preferredLanguage;
              })?.nativeName ?? t('menu.aiLanguageSelect')}
            </div>
          </div>
        </div>
      )}

      <MindverseModal
        cancelText={t('common.cancel')}
        destroyOnClose
        maskClosable={false}
        okText={t('common.save')}
        onCancel={() => setShowModal(false)}
        onOk={onOk}
        open={showModal}
        size={SizeType.normal}
        title={t(MenuTNameMap[MenuItem.PreferredLanguage])}
      >
        <PreferLanguage
          languageCode={selectedLanguage || 'en'}
          languageList={languageList}
          setSelectedLanguage={setSelectedLanguage}
        />
      </MindverseModal>
    </>
  );
};

export default PreferredLanguageItem;
